import { render, staticRenderFns } from "./EventEmployeeAdd.vue?vue&type=template&id=96f1d242&scoped=true"
import script from "./EventEmployeeAdd.vue?vue&type=script&lang=js"
export * from "./EventEmployeeAdd.vue?vue&type=script&lang=js"
import style0 from "./EventEmployeeAdd.vue?vue&type=style&index=0&id=96f1d242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f1d242",
  null
  
)

export default component.exports